/* Mutations are needed to change to a state, it will be sent to the store via actions. */
import TYPES from "./mutation-types";

export default {
  [TYPES.LOGIN](state, user) {
    state.user = user || {};
  },
  [TYPES.LOGOUT](state) {
    state.user = {};
  },
  [TYPES.SUBSCRIBE_TO_MOMENT_REMINDERS](state) {
    state.notifications.reminders = true;
  },
  [TYPES.SETDATE](state, newDate) {
    state.selectedDate = newDate;
  },
  [TYPES.SETPERIOD](state, newPeriod) {
    state.selectedPeriod = newPeriod;
  },
  [TYPES.SET_COOKIE_CONSENT](state) {
    state.cookieConsented = true;
  }
};
